import { api } from "@/lib/api";

export async function download(url, params, fallback) {
  const res = await api.get(url, { params, responseType: "blob" });
  const cd = res.headers["content-disposition"] || "";
  const name = (cd.match(/filename="?([^"]+)"?/) || [])[1] || fallback;
  const href = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(href), 1000);
  return name;
}

export async function downloadPost(url, fallback) {
  const res = await api.post(url, null, { responseType: "blob" });
  const cd = res.headers["content-disposition"] || "";
  const name = (cd.match(/filename="?([^"]+)"?/) || [])[1] || fallback;
  const href = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(href), 1000);
  return name;
}

export const RANGE_KEYS = [["today", "Bugün"], ["yesterday", "Dün"], ["week", "Bu Hafta"], ["month", "Bu Ay"], ["last_month", "Geçen Ay"], ["year", "Bu Yıl"], ["custom", "Özel Tarih"]];
